import React from "react";
import { NavLink, useNavigate, Link } from "react-router-dom";
import api from "../lib/api";
import { Inbox, Briefcase, MessageSquare, Settings, ExternalLink, LogOut, Newspaper } from "lucide-react";

const links = [
  { to: "/admin/leads", label: "Leads", icon: Inbox },
  { to: "/admin/projects", label: "Projects", icon: Briefcase },
  { to: "/admin/reviews", label: "Reviews", icon: MessageSquare },
  { to: "/admin/blog", label: "Blog", icon: Newspaper },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout({ children }) {
  const navigate = useNavigate();
  const signOut = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignore
    }
    navigate("/admin");
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-[#0b0e13] flex">
      <aside className="w-[260px] shrink-0 bg-[#0d1218] border-r border-white/5 flex flex-col fixed h-screen">
        <div className="px-6 py-6 border-b border-white/5">
          <div className="flex items-center gap-3">
            <img src="/assets/logo.png" alt="logo" className="w-10 h-10 object-contain bg-white rounded-lg p-1" />
            <div>
              <div className="text-white font-display font-bold leading-tight">Classic Interior</div>
              <div className="text-[#2f9fe6] text-[11px] tracking-[0.22em]">CMS</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 py-6 px-3 space-y-1">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg text-[15px] transition-colors ${isActive ? "bg-[#2f9fe6]/15 text-[#2f9fe6]" : "text-[#9aa4af] hover:text-white hover:bg-white/5"}`}>
              <l.icon className="w-5 h-5" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/5 space-y-1">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-4 py-3 rounded-lg text-[#9aa4af] hover:text-white hover:bg-white/5 transition-colors text-[15px]">
            <ExternalLink className="w-5 h-5" /> View Site
          </Link>
          <button onClick={signOut} className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-[#9aa4af] hover:text-red-400 hover:bg-red-500/10 transition-colors text-[15px]">
            <LogOut className="w-5 h-5" /> Sign Out
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-[260px] p-8 lg:p-12 min-h-screen">{children}</main>
    </div>
  );
}
